// extracted by mini-css-extract-plugin
export var block = "Promotional-module--block--UIgzX";
export var center = "Promotional-module--center--rvcp0";
export var left = "Promotional-module--left--2rYmb";
export var right = "Promotional-module--right--ki1Pc";
export var root = "Promotional-module--root--Ytv3C";